import { render, staticRenderFns } from "./tabWarning.vue?vue&type=template&id=564ccb1e&"
import script from "./tabWarning.vue?vue&type=script&lang=js&"
export * from "./tabWarning.vue?vue&type=script&lang=js&"
import style0 from "./tabWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564ccb1e')) {
      api.createRecord('564ccb1e', component.options)
    } else {
      api.reload('564ccb1e', component.options)
    }
    module.hot.accept("./tabWarning.vue?vue&type=template&id=564ccb1e&", function () {
      api.rerender('564ccb1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/PreWarning/components/tabWarning.vue"
export default component.exports